<template>
  <div class="d-flex justify-space-between pt-5">
    <div>
      <v-btn
        :loading="loading"
        :disabled="!isAllDatesInFilter"
        small
        color="primary"
        class="white--text px-4"
        @click="getReport"
      >
        <v-icon left size="20">mdi-file-chart-outline</v-icon>Сформировать отчет
      </v-btn>
    </div>

    <v-btn
      text
      color="accent"
      :ripple="false"
      class="show-filter px-0 ml-4"
      @click="$emit('setShowFilter')"
    >
      <v-icon left size="20">mdi-filter-outline</v-icon>
      Фильтры
      <v-icon left size="20" class="ml-1 mr-0">{{ showFilter ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { workloadApi } from '@/api'
import { mapGetters } from 'vuex'
import download from '@/plugins/download'

export default {
  name: 'EmployeesLoadButtons',

  props: {
    showFilter: Boolean,
    filters: Object
  },

  data: () => ({
    loading: false
  }),

  computed: {
    ...mapGetters('department', ['departmentId']),

    isAllDatesInFilter() {
      return this.filters?.fromDate && this.filters?.toDate
    }
  },

  methods: {
    async getReport() {
      try {
        this.loading = true

        const body = {
          departmentId: this.departmentId,
          fromDate: this.filters?.fromDate || null,
          toDate: this.filters?.toDate || null
        }

        const data = await workloadApi.getEmplLoadToXls(body)
        data && download(data, 'Отчет по педагогической нагрузке.xlsx')
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка формирования отчета')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>